import type { SesionResumen } from './consultas'
import { formatearFecha } from './formato'
import { InsigniaAnimo } from './InsigniaAnimo'

interface Props {
  sesiones: SesionResumen[]
  seleccionada: string | null
  onSeleccionar: (id: string) => void
}

/**
 * El listado lateral. La **etiqueta** viene ya resuelta del backend y aqui no
 * se deriva nada de ella: en clientes es el nombre de perfil de WhatsApp (que
 * puede ser `.`, un emoji o llevar una arroba) y en leads el numero o el aviso
 * de dispositivo vinculado. Partir por `@` o dar por hecho que es un telefono
 * es justo el defecto que se esta corrigiendo.
 */
export function ListaSesiones({ sesiones, seleccionada, onSeleccionar }: Props) {
  return (
    <ul className="flex flex-col gap-1">
      {sesiones.map((sesion) => {
        const activa = sesion.id === seleccionada
        const fecha = formatearFecha(sesion.ultima_fecha)
        // En leads la etiqueta ya es el telefono: repetirlo debajo es ruido.
        const telefono = sesion.telefono && sesion.telefono !== sesion.etiqueta ? sesion.telefono : null

        return (
          <li key={sesion.id}>
            <button
              type="button"
              aria-label={`Conversación de ${sesion.etiqueta}`}
              aria-current={activa ? 'true' : undefined}
              onClick={() => onSeleccionar(sesion.id)}
              className={[
                // min-h-14: objetivo tactil comodo, que esta seccion se
                // consulta sobre todo desde el movil.
                'flex w-full min-h-14 flex-col rounded-lg border px-3 py-2 text-left transition-colors',
                activa
                  ? 'border-acento-borde bg-acento-suave'
                  : 'border-transparent bg-superficie hover:border-borde hover:bg-elevado',
              ].join(' ')}
            >
              <span className="flex items-baseline justify-between gap-2">
                <span className="truncate text-sm font-medium text-tinta">
                  {sesion.etiqueta}
                </span>
                {fecha ? (
                  <span className="shrink-0 text-xs text-tinta-apagada">{fecha}</span>
                ) : null}
              </span>
              <span className="mt-1 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-tinta-apagada">
                {telefono ? <span>{telefono}</span> : null}
                <span>{sesion.mensajes} mensajes</span>
                <InsigniaAnimo meta={sesion.meta} />
              </span>
            </button>
          </li>
        )
      })}
    </ul>
  )
}
